/**
 * Descarga un archivo generado en memoria sin tocar la red ni usar
 * `innerHTML`. Equivale a `Content-Disposition: attachment` en un backend: el
 * atributo `download` fuerza siempre el guardado en vez de la navegación.
 */
export function downloadFile(filename: string, content: string, mimeType: string): void {
  const blob = new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.rel = "noopener";
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
}
